<template>
  <el-dialog
    title="Comissão do Corretor"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    @open="reset"
    width="35%"
  >
    <el-form size="small" label-position="top">
      <el-form-item label="Corretor" style="width: 100%">
        <el-select
          v-model="usuarioSelecionado"
          :remote-method="filtrarUsuariosSelect"
          :loading="loadingUsuarios"
          value-key="id"
          placeholder
          v-if="!comissaoImobiliaria"
          loading-text="Carregando usuários"
          no-data-text="Nenhum usuário encontrado"
          filterable
          remote
          reserve-keyword
          style="width: 100%"
        >
          <el-option
            v-for="item in usuariosDisponiveis"
            :key="item.id"
            :label="item.nome"
            :value="item"
          ></el-option>
        </el-select>

        <el-input value="IMOBILIÁRIA" v-if="comissaoImobiliaria" readonly></el-input>
      </el-form-item>

      <el-col :span="6">
        <el-form-item label="Comissão(%)">
          <div class="el-input el-input--small">
            <money
              v-model="comissao"
              v-bind="percent"
              @input="calcularValorComissao"
              class="el-input__inner"
            />
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="7">
        <el-form-item label="Comissão(R$)">
          <div class="el-input el-input--small">
            <money v-model="valorComissao" v-bind="money" class="el-input__inner" readonly/>
          </div>
        </el-form-item>
      </el-col>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="fechar">Fechar</el-button>
      <el-button @click="adicionarComissaoVenda" type="primary">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Money } from "v-money";

export default {
  components:{
    Money
  },
  props: {
    visibility: Boolean,
    comissaoImobiliaria: Boolean
  },
  data() {
    return {
      loadingUsuarios: false,
      usuarioSelecionado: { id: 0, nome: "" },
      comissao: Number,
      valorComissao: Number,
      
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      },
    };
  },
  computed: {
    ...mapState("vendasStore", {
      venda(state) {
        return state.vendaSelecionada;
      },
      usuariosDisponiveis() {
        return this.$store.state.vendasStore.usuariosDisponiveis;
      }
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasStore", ["listarUsuarios"]),
    filtrarUsuariosSelect(queryString) {
      let payload = { nome: queryString };
      this.loadingUsuarios = true;
      this.listarUsuarios(payload).then(response => {
        this.loadingUsuarios = false;
      });
    },
    adicionarComissaoVenda() {
      let comissaoVenda = {
        id: 0,
        corretor: {
          id: this.usuarioSelecionado.id,
          nome: this.usuarioSelecionado.nome
        },
        percentual: this.comissao,
        valor: this.valorComissao
      };
      this.venda.comissoes.push(comissaoVenda);
      this.fechar();
    },
    reset() {
      this.usuarioSelecionado = { id: 0 };
      this.comissao = "";
      this.valorComissao = "";
    },
    fechar() {
      this.$emit("close");
    },
    calcularValorComissao() {
      let totalComissao = this.venda.valorComissao;
      this.valorComissao = (
        (totalComissao * (this.comissao * 100)) /
        10000
      ).toFixed(2);
    },
    calcularComissao() {
      let totalComissao = this.venda.valorComissao;
      this.comissao = ((this.valorComissao / totalComissao) * 100).toFixed(2);
    }    
  }
};
</script>

